import { render, staticRenderFns } from "./friends.html?vue&type=template&id=2e49b74c&scoped=true&external"
import script from "./Friends.vue?vue&type=script&lang=js"
export * from "./Friends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49b74c",
  null
  
)

export default component.exports